import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';
import '../styles/SignUp.css';

function ParentDualSchoolLogin() {
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const DUAL_SCHOOL_PARENT_CODE = 'DUAL_SCHOOL_PARENT'; // Replace with actual code if needed
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const fetchCurrentUserAndNavigate = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const headers = {
          'Authorization': `Token ${token}`,
        };
        await axios.get(`${API_ENDPOINT}/api/current-user/`, { headers });
        navigate('/parent-home');
      }
    } catch (error) {
      console.error("Error fetching current user:", error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    try {
      await axios.post(`${API_ENDPOINT}/api/register/`, {
        first_name: firstName,
        last_name: lastName,
        email,
        password,
        signup_code: DUAL_SCHOOL_PARENT_CODE,
      });
      // After successful registration, log the user in
      const loginResponse = await axios.post(`${API_ENDPOINT}/api/login/`, {
        email,
        password,
      });
      localStorage.setItem('token', loginResponse.data.token);
      // Reset applicationStep for new user
      localStorage.setItem('applicationStep', '0');
      await axios.get(`${API_ENDPOINT}/api/current-user/`, {
        headers: { Authorization: `Token ${loginResponse.data.token}` },
      });
      navigate('/application');
      window.location.reload();
    } catch (error) {
      setError('Registration failed! Please check your information and try again.');
      console.error('Error registering', error);
    }
  };

  return (
    <div className="signup-page">
      <Container className="signup-container">
        <h2 className="center-text">Apply to Dual School</h2>
        <p className="center-text">Already have an account? <Link to="/log-in">Sign In</Link></p>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formFirstName">
            <Form.Label className="bold-label">First Name</Form.Label>
            <Form.Control type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formLastName">
            <Form.Label className="bold-label">Last Name</Form.Label>
            <Form.Control type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label className="bold-label">Email</Form.Label>
            <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formPassword">
            <Form.Label className="bold-label">Password</Form.Label>
            <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formConfirmPassword">
            <Form.Label className="bold-label">Confirm Password</Form.Label>
            <Form.Control type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
          </Form.Group>
          {error && <div className="center-text" style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
          <div className="center-text">
            <Button variant="primary" type="submit" className="btn-block custom-button">
              Create Account
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
}

export default ParentDualSchoolLogin; 